<template>
  <section class="osd-section">
    <header
      class="osd-section__header"
      :class="{ 'osd-section__header--stacked': description }"
    >
      <v-icon class="osd-section__header-icon" :icon="icon" size="18" />
      <div class="osd-section__heading">
        <span class="osd-section__title">{{ title }}</span>
        <p v-if="description" class="osd-section__desc">{{ description }}</p>
      </div>
    </header>
    <div class="osd-section__body">
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: "OrgSettingsDialogSection",
  props: {
    title: { type: String, default: "Settings details" },
    icon: { type: String, default: "mdi-cog-outline" },
    description: { type: String, default: "" },
  },
};
</script>
